module.exports = __webpack_public_path__ + "img/absolute-wallpaper.cb96d8e7.svg";